/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { EventArgs, markType } from "igniteui-react-core";
/**
 * @hidden
 */
var DefinitionPropertyUpdatedEventArgs = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(DefinitionPropertyUpdatedEventArgs, _super);
    function DefinitionPropertyUpdatedEventArgs() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._propertyName = null;
        _this._animationType = 0;
        _this._oldValue = null;
        _this._newValue = null;
        return _this;
    }
    Object.defineProperty(DefinitionPropertyUpdatedEventArgs.prototype, "propertyName", {
        get: function () {
            return this._propertyName;
        },
        set: function (a) {
            this._propertyName = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionPropertyUpdatedEventArgs.prototype, "animationType", {
        get: function () {
            return this._animationType;
        },
        set: function (a) {
            this._animationType = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionPropertyUpdatedEventArgs.prototype, "oldValue", {
        get: function () {
            return this._oldValue;
        },
        set: function (a) {
            this._oldValue = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionPropertyUpdatedEventArgs.prototype, "newValue", {
        get: function () {
            return this._newValue;
        },
        set: function (a) {
            this._newValue = a;
        },
        enumerable: true,
        configurable: true
    });
    DefinitionPropertyUpdatedEventArgs.$t = markType(DefinitionPropertyUpdatedEventArgs, 'DefinitionPropertyUpdatedEventArgs', EventArgs.$);
    return DefinitionPropertyUpdatedEventArgs;
}(EventArgs));
export { DefinitionPropertyUpdatedEventArgs };
//# sourceMappingURL=DefinitionPropertyUpdatedEventArgs.js.map
